// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideWand2 as RawLucideWand2 } from "lucide-react";
export const LucideWand2 = /* @__PURE__ */ createIcon(RawLucideWand2, "LucideWand2", 2);
